// This class contains the necessary method of gathering Everplans-related plan data
// getFormMappings() would return an array of FoxIt fields with the corresponding value
import { FormMapping } from './FormMapping'

export default class EverplansForm extends FormMapping {
	constructor(planHolderId: string) {
		super(planHolderId)
	}

	getFormMappings() {
		return [
			...this.getFuneralHomeMapping(),
			...this.getPolicyOwnerMapping(),
			{ name: 'agentName', value: this.getSalesContactName() },
			{
				name: 'purchaserEmail',
				value: this.planHolder.everplansEmail ?? '',
			},
		]
	}
}
